export default function ({ route, redirect, $cookies, localePath, i18n }) {
  const appKey = i18n.localeProperties.appKey;

  // Check if payment has been initiated
  const isPaymentInitiated = $cookies.get(`${appKey}pinit`);
  
  // Check if the order has been placed
  const isOrderPlaced = $cookies.get(`${appKey}iOp`);
  
  // Check if the order has been cancelled
  const isOrderCancelled = $cookies.get(`${appKey}iOc`) || $cookies.get(`${appKey}iOr`);
  
  // Define the pages
  const orderConfirmationPage = localePath(i18n.t('PAGES.ORDER_CONFIRMATION'));
  const ongoingOrRefusedPaymentPage = localePath(i18n.t('PAGES.ONGOING_OR_REFUSED_PAYMENT'));
  
  // Detect if user returned via back button after external payment page redirect
  if (process.client) {
    const isPendingPayment = sessionStorage.getItem('pendingPayment');
    if (isPendingPayment) {
      // force redirect to ongoing payment page
      return redirect(ongoingOrRefusedPaymentPage);
    }
  }

  // If order has been placed, redirect to order confirmation page
  if (isOrderPlaced) {
    if (route.path !== orderConfirmationPage) {
      return redirect(orderConfirmationPage);
    }
  } 
  // If payment is initiated and order is cancelled, redirect to ongoing or refused payment page
  else if (isPaymentInitiated && isOrderCancelled) {
    if (route.path !== ongoingOrRefusedPaymentPage) {
      return redirect(ongoingOrRefusedPaymentPage);
    }
  }
}